import React, { useState } from "react";
import Typical from "react-typical";
import axios from "axios";
import { toast } from "react-toastify";
import imgBack from "../../../src/images/mailz.jpeg";
import load1 from "../../../src/images/load2.gif";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import Footer from "../Footer/Footer";
import "./ContactMe.css";

export default function ContactMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);

  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };
  //  console.log(name);
  const submitForm = async (e) => {
    e.preventDefault();

    const options = {
      method: "POST",
      url: "https://mail-sender-api1.p.rapidapi.com/",
      headers: {
        "x-rapidapi-key": "d06bf420a7msh224baee09169fbdp12afdajsn1a8d01296873",
        "x-rapidapi-host": "mail-sender-api1.p.rapidapi.com",
        "Content-Type": "application/json",
      },
      data: {
        sendto: "deepakshinde3346@gmail.com",
        name: name,
        replyTo: email,
        ishtml: "false",
        title: "Recruter Mail",
        body: message,
      },
    };

    try {
      const response = await axios.request(options);
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="main-container fade-in" id={props.id || ""}>
      <ScreenHeading
        subHeading={" Keep In Touch Stranger"}
        title={"Contact Me"}
      />
      <div className="central-form">
        <div className="col">
          <h2 className="title">
            <Typical
              loop={Infinity}
              steps={["Get In Touch 📧 Stranger🤙", 1000]}
            />
          </h2>
          <a href="https://github.com/dipakshinde-art/" target="_blank">
            <i className="fa fa-github-square"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/dipak-shinde-2857461b6/"
            target="_blank"
          >
            <i className="fa fa-linkedin-square"></i>
          </a>
          <a href="https://www.instagram.com/mr_d_i_p_a_k____/" target="_blank">
            <i className="fa fa-instagram"></i>
          </a>
          <a href="https://twitter.com/mr_D_17" target="_blank">
            <i className="fa fa-twitter"></i>
          </a>
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>Send Your Email Here!</h4>
            <img src={imgBack} alt="image not found" />
          </div>
          <form onSubmit={submitForm}>
            <p>{banner}</p>
            <label htmlFor="name">Name</label>
            <input type="text" onChange={handleName} value={name} />

            <label htmlFor="email">Email</label>
            <input type="email" onChange={handleEmail} value={email} />

            <label htmlFor="message">Message</label>
            <textarea type="text" onChange={handleMessage} value={message} />

            <div className="send-btn">
              <button type="submit">
                send &nbsp;
                <i className="fa fa-paper-plane" />
                {bool ? (
                  <b className="load">
                    <img src={load1} alt="image not responding" />
                  </b>
                ) : (
                  ""
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
